var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1","height":"88","fill":"none"}},[_c('path',{attrs:{"fill":"#E0E2E6","d":"M0 88h1V0H0z"}})])
}
var staticRenderFns = []

export default { render: render }